import { render, staticRenderFns } from "./SiteBanner.vue?vue&type=template&id=18c797a2&scoped=true"
var script = {}
import style0 from "./SiteBanner.vue?vue&type=style&index=0&id=18c797a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c797a2",
  null
  
)

export default component.exports